import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'
import { fromJS } from 'immutable';

export default (file,uploadType,senderWord,clientId,divisionId,idtype) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    const Authorization = UserToken;
    const url = ApiUrl2 + 'upload-file';

    const data = new FormData();
    data.append('file', file );
    //tambahan
    data.append('senderwords',senderWord)
    data.append('clientid',clientId)
    data.append('divisionid',divisionId)

    const argument = {
        method: 'POST',
        headers : {
            'Authorization': Authorization,
            'Upload-type':uploadType,
			'Id-type':idtype
        },
        body : data
    };
    const response = await doFetch(url,argument);
    
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });

    try{
        if(response.ok){
            var res = fromJS(await response.json());
            res = res.get('upload-files');
            res = res.get(0)
            return fromJS({
                'success': true,
                "file-id": res.get('file-id'),
                "file-name": res.get('file-name'),
                "data-file": res.get('data-file'),
                "max-msisdn-uat":res.get('max-msisdn-uat')
            });
        }
    }catch(ex){

    }
    
    return fromJS({
        'success': false
    })
};